import { Component, OnInit, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs/Rx';

import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { FluxoInscricaoService } from '../shared/fluxoInscricao.service';

import { DadosPagamento } from 'models/dados-pagamento';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './pagamento.component.html',
  styleUrls: ['./pagamento.component.scss'],
  animations: [routerTransition],
})
export class PagamentoComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  dadosInscricao: any = undefined;
  formaPagamento: any = undefined;
  esconderBotaoFinalizacao = false;
  dadosPagamento: BehaviorSubject<DadosPagamento> = new BehaviorSubject<DadosPagamento>(new DadosPagamento({}));

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fluxoInscricaoService: FluxoInscricaoService,
  ) { }

  ngOnInit() {
    this.dadosInscricao = this.fluxoInscricaoService.getDadosInscricao();
    this.init();
  }

  init() {
    const {
      candidato: {cpf, nome},
      parcelamentoSelected: {valorParcela, desconto},
      inscricao: { inscricao },
    } = this.dadosInscricao;

    const valorTotal = valorParcela - desconto.valor;

    this.dadosPagamento.next(new DadosPagamento({
      dadosPessoais: {
        cpd: 0,
        cpf,
        nome,
        numInscricao: inscricao,
      },
      valorTotal,
      valorParcela,
      desconto: desconto.valor,
      sistema: {
        codigoSistema: 5,
        nomeSistema: 'POS GRADUACAO',
        servico: {
          codigo: 14,
          descricao: 'Pagamento de Inscrição Pós-Graduação',
          valorTotal,
        },
      },
    }));
  }

  onPagamentoSucesso(formaPagamento) {
      this.formaPagamento = formaPagamento;
      if (formaPagamento.id === 'cartao') {
        this.nextStep();
      }
  }

  onMudancaPagamento(mudancaPagamento) {
    this.esconderBotaoFinalizacao = mudancaPagamento === 'cartao';
  }

  nextStep() {
    this.fluxoInscricaoService.proximoPasso({
      pagamento: {
        formaPagamento: this.formaPagamento,
      },
    });
    const proximaRota = this.fluxoInscricaoService.proximaRota();
    this.router.navigate([`../${proximaRota}`], { relativeTo: this.route });
  }
}
